import { computed, ref } from 'vue'

export default {
    name: 'ColorPreview',
    setup() {
        const cssClass = ref('test \n igen')

        const config = ref({
            '--colortheme-primary': '#dcdcdc',
            '--colortheme-secondary': '#4e4e4e',
            '--colortheme-spot': '#990000',
            '--colortheme-text': '#000000',
            '--colortheme-icon': '#990000',
            '--colortheme-quote': '#4e4e4e'
        })

        const string = computed(
            () =>
                Object.entries(config.value).reduce((string, entry) => {
                    string += `\t${entry[0]}:${entry[1]};\n`
                    return string
                }, `html {\n`) + '\n}'
        )

        const themeClassName = computed(() => {
            return `kb-colortheme--${themeName}`
        })

        const insert = function () {
            remove()
            let el = document.createElement('style')
            el.setAttribute('type', 'text/css')
            el.setAttribute('data', 'custom')
            el.innerText = string.value
            document.head.appendChild(el)
        }

        const remove = function () {
            document.querySelector('style[data="custom"]')?.remove()
        }

        const copy = function () {
            let copyText = document.querySelector('#cssoutput')
            copyText.removeAttribute('disabled')
            copyText.select()
            document.execCommand('copy')
            copyText.setAttribute('disabled', 'disabled')
        }

        return {
            config,
            copy,
            cssClass,
            insert,
            remove,
            string
        }
    }
}
